export default "__VITE_ASSET__B7jjiZXG__"